<template>
  <v-card class="card">
    <v-form
      @submit.prevent="save"
      ref="form"
      style="max-height: 100vh; overflow-y: auto; overflow-x: hidden"
    >
      <v-card-item>
        <v-card-title
          >Add <b>Data Model Details</b>
          <Button
            boxIcon="mdi-close"
            variant="text"
            class="float-right"
            @click="closeDialog"
          />
        </v-card-title>
      </v-card-item>
      <v-card-text>
        <v-row no-gutters class="pa-0">
          <v-col cols="12">
            <v-label class="label"
              >Column Name<span class="labelStar">*</span></v-label
            >
            <TextFieldComponent
              v-model="formData.column_name"
              placeholder="Column Name"
              @keyup="checkName"
              :hide-details="codeError && true"
            />
            <v-error v-if="codeError" class="text-red">Already Exists!</v-error>
          </v-col>
          <v-col cols="12">
            <v-label class="label"
              >Label <span class="labelStar">*</span></v-label
            >
            <TextFieldComponent
              v-model="formData.label"
              placeholder="Label"
              @keyup="checkName"
              :hide-details="codeError && true"
            />
            <v-error v-if="codeError" class="text-red">Already Exists!</v-error>
          </v-col>
          <!-- <v-col cols="12" class="py-0 pb-3">
            <v-label class="label"> Data type </v-label>
            <EnumLookUp
              :value="'data_value'"
              :name="'display_value'"
              :domain="'DATA-TYPE'"
              variant="outlined"
              class="lookup"
              v-model="formData.data_type"
            ></EnumLookUp
          ></v-col> -->
        </v-row>
      </v-card-text>
      <v-card-actions class="mr-3">
        <v-row justify="end" class="dialogBottom d-flex ga-2">
          <Button name="Cancel" class="cancel" @click="closeDialog" />
          <Button name="Save" type="submit" class="save" />
        </v-row>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { TextFieldComponent, Button } from "@tiburadev/vue-comp3";
import DatamodelDetailsService from "@/api/service/DataModelDetails/DataModelsDetailsService";
// import { EnumLookUp } from "@tiburadev/enums";
// import { getRules } from "@tiburadev/fe-utilities";
// import DataModelDetailsService from "../api/service/data-model-details-service";

export default {
  components: {
    TextFieldComponent,
    Button,
    // EnumLookUp
  },
  props: ['modelId'],
  data() {
    return {
      codeError: false,
      formData: {}
    }
  },
  methods: {
    // getRules,
    closeDialog() {
      this.$emit("close-dialog");
    },
    checkName() {
      // Add validation logic here if needed
    },
    async save() {
      let validation = await this.$refs.form.validate();
      if (!validation.valid || this.codeError) {
        return;
      } else {
        this.formData.model_id = this.modelId;
        if (this.modelId) {
          try {
            await DatamodelDetailsService.create(this.formData);
          } catch (e) {
            console.log(e, "error");
          }
        }
        this.closeDialog();
        this.formData = {};
      }
    }
  }
}
</script>
<style scoped>
.dialog-title {
  padding: 0;
  margin-bottom: 0.9375rem;
  display: flex;

  justify-content: space-between;
}
.title-heading {
  font-size: 1.125rem;
  font-weight: 600;
}
.dialog-card {
  background-color: white;
  border-radius: 0.5rem;
  padding: 1.25rem 1.5625rem;
  width: 700px;
  height: 530px;
  overflow-y: auto;
  align-self: center;
}
.labelStar {
  color: #cf0707;
  padding-left: 2px;
  font-weight: 700;
}
.label {
  font-size: 14px;
  color: #272727;
  font-weight: 500;
  padding-bottom: 6px;
}

.v-selection-control {
  /* align-items: center; */
  contain: layout;
  display: flex;
  flex: 1 0;
  grid-area: control;
  position: relative;
  user-select: none;
}
.v-switch.v-input {
  flex: 0 1 auto;
  margin-bottom: -33px;
  /* padding-bottom: 3px; */
  margin-top: 0px;
}
.v-messages {
  flex: 1 1 auto;
  font-size: 12px;
  min-height: 14px;
  min-width: 1px;
  opacity: var(--v-medium-emphasis-opacity);
  position: relative;
  display: flex;
  top: 5px;
}
.v-input {
  display: block;
  flex: 1 1 auto;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  margin-top: 5px;
}
.enumTitle {
  font-size: 20px;
}
.removeIcon {
  border: 1px solid #c2c2c2;
  padding: 16px;
  border-radius: 5px;
}
.outlined {
  border: 1px solid #e6e6e6;
  background-color: #fafafa;
  border-radius: 8px;
}
.card-selected {
  border: 1px solid #6ff8ff;
  background-color: #ebfeff;
}
>>> .lookup .v-input--density-default {
  --v-input-control-height: 22px !important;
  --v-input-padding-top: 0px !important;
}
>>> .lookup .v-field__field .v-field__input {
  padding-bottom: 0px !important;
}
</style>
